import { render, staticRenderFns } from "./ReservationConfirmation.vue?vue&type=template&id=2217ede8"
import script from "./ReservationConfirmation.vue?vue&type=script&lang=js"
export * from "./ReservationConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports